

@if(routeItem()){
    <map-marker 
        [position]="routeItem().currentLocation"
        [options]="getItemOptions(routeItem())" 
    />

    @for(item of routeItem()?.relatedsItems; track item.id; ) {
        {{ item | json }}
        <map-marker 
            (mapClick)="handleRecommendedMarkerClick(item)" 
            [position]="item.currentLocation"
            [options]="recommendedMarkerOption()" 
        />
    }
}
